import React from 'react';
import cn from 'classnames';
import PointsIcon from '@wix/da-ds/pkg/Icons/Points';
import { IconSize } from '@wix/da-ds/pkg/Icons/IconWrap';
import s from './CommissionPointsAndPrice.scss';
const CommissionPointsAndPrice = ({ points, price, dollarsClassName, pointsClassName })=>{
    return /*#__PURE__*/ React.createElement("div", {
        className: s['root']
    }, /*#__PURE__*/ React.createElement("div", {
        className: cn(s['dollars-price'], dollarsClassName)
    }, price), points && /*#__PURE__*/ React.createElement("div", {
        className: cn(s['points-price'], pointsClassName)
    }, /*#__PURE__*/ React.createElement(PointsIcon, {
        className: s['points-icon'],
        size: IconSize.TINY,
        disableDefaultColors: true
    }), points));
};
CommissionPointsAndPrice.displayName = 'CommissionPointsAndPrice';
export default CommissionPointsAndPrice;
